<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 15:20:46
--> 
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled='readonly'
                       :showEdit="hasBtn('edit-staff-movement')&&$store.state.listObj.result_status==0"
                       :show_del="hasBtn('delete-staff-movement')&&$store.state.listObj.result_status==0"
                       :showReturn='false'
                       @handleEdit='handleEdit'
                       @handleDel='handleDel'></mrc_ess_iconGroup>
    <staffVariation :disabled='readonly'
                    @changeReadonly='handleEdit'></staffVariation>
  </div>
</template>

<script>
import { deleteStaffVariation } from '@/service/api/staffmsg.js'
import staffVariation from './staffVariation'
export default {
  components: {
    staffVariation
  },
  props: {},
  data () {
    return {
      readonly: false,
      list: {}
    };
  },
  computed: {},
  created () { },
  watch: {
    readonly: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_employee_change'
          this.$store.commit('set_page_title', 'label_edit_employee_change')
        }
        else {
          this.$route.meta.title = 'label_view_employee_change'
          this.$store.commit('set_page_title', 'label_view_employee_change')
        }
      }, immediate: true
    }
  },
  mounted () {
    this.readonly = this.$store.state.iconstatus
  },
  beforeDestroy () {

  },
  methods: {
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
        deleteStaffVariation({ uuid: this.$store.state.uuid }).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_The_deletion_was_successful') })
            this.$router.push({
              name: 'staffVariation'
            })
          }
        })
      })
    },
  },
};
</script>

<style scoped>
</style>
